import Service from "./Service";

const basePath = '/api/curso-maternidad';

const listSesiones = () => {
    const url = `${basePath}/sesiones`;
    return Service.get(url);
}

const listHistoriaSesiones = (idEmbarazo) => {
    const url = `${basePath}/historia-sesiones/${idEmbarazo}`;
    return Service.get(url);
}

const saveSesion = (data) => {
    const url = `${basePath}/historia-sesiones`;
    return Service.post(url, data);
}

export  {
    listSesiones,
    listHistoriaSesiones,
    saveSesion
}
